import React, { useEffect, useState } from "react";
import Layout from "../components/Layout/HomeLayout";
import TripDetails from "../components/TripDetails/TripDetails";
import TalkToExpert from "../components/LandingPage/TalkToExpert";
import Testmonials from "../components/LandingPage/Testmonials";
import SiteReviews from "../components/SiteReviews";
import HomeBlogs from "../components/LandingPage/HomeBlogs";
import Faq from "../components/Faq";
import Form from "../components/Contact/Form";
import bannerImage from "../images/bannernew.jpeg";
import NyeFaq from "../components/NyeFaq";

import axios from "axios";
import "./nyetrips.css"; // ✅ styles applied here

const NYEPage = () => {
  const [allTrips, setAllTrips] = useState([]);
  const [communityTrips, setCommunityTrips] = useState([]);
  const [indiaTrips, setIndiaTrips] = useState([]);
  const [internationalTrips, setInternationalTrips] = useState([]);

  const getAllTrips = async () => {
    try {
      const res = await axios.get(`api/trips/get-all-trips`);
      if (res.data.success) {
        const trips = res.data.data;

        setCommunityTrips(
          trips.filter((t) =>
            t?.category?.some((c) =>
              c.toLowerCase().includes("nye community trip")
            )
          )
        );

        setIndiaTrips(
          trips.filter((t) =>
            t?.category?.some((c) => c.toLowerCase().includes("nye india trips"))
          )
        );

        setInternationalTrips(
          trips.filter((t) =>
            t?.category?.some((c) =>
              c.toLowerCase().includes("nye international trips")
            )
          )
        );

        setAllTrips(trips);
      }
    } catch (err) {
      console.error("Error fetching trips:", err);
    }
  };

  useEffect(() => {
    getAllTrips();
    document.title = "High Mountains - NYE Trips 2025";
  }, []);

  return (
    <Layout
      trip={allTrips}
      title="Celebrate New Year’s Eve"
      subTitle="Choose from our special NYE trips across India and beyond!"
    >
      {/* ===== NYE HERO BANNER ===== */}
      <div className="nye-banner-section">
<div
  className="nye-banner"
  style={{
    backgroundImage: `url(${bannerImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
  }}
></div>

  {/* 🟡 Overlay Form on Banner */}
  <div className="nye-form-overlay">
    <Form whiteBg={true} />
  </div>
</div>

      {/* ===== NYE Sections ===== */}
      <div className="container">
        {communityTrips?.length > 0 && (
          <div className="section-wrapper">
            <h2 className="section-title">NYE Packages</h2>
            <div className="trip-grid">
            <TripDetails
  data={communityTrips}
  title="NYE Community Trips"
  category="NYE Community Trip"
  customLink="category/NYE Community Trip"  // ✅ this works
    hideMonthFilter={true}   // ✅ this hides Jan/Dec dropdown

/>


            </div>
          </div>
        )}

        {indiaTrips?.length > 0 && (
          <div className="section-wrapper">
            {/* <h2 className="section-title">NYE India Trips</h2> */}
            <div className="trip-grid">
             <TripDetails
  data={indiaTrips}
  title="NYE India Trips"
  category="NYE India Trips"
  customLink="category/NYE India Trips"
    hideMonthFilter={true}   // ✅ this hides Jan/Dec dropdown

/>

            </div>
          </div>
        )}

        {internationalTrips?.length > 0 && (
          <div className="section-wrapper">
            {/* <h2 className="section-title">NYE International Trips</h2> */}
            <div className="trip-grid">
              <TripDetails
  data={internationalTrips}
  title="NYE International Trips"
  category="NYE International Trips"
  customLink="category/NYE International Trips"
    hideMonthFilter={true}   // ✅ this hides Jan/Dec dropdown

/>

            </div>
          </div>
        )}
      </div>

      {/* Footer sections */}
<SiteReviews limit={6} variant="grid" showButton={true} />
           <Testmonials />
    <HomeBlogs />
      <NyeFaq />

    </Layout>
  );
};

export default NYEPage;
